// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"0eebab7c","362":"684e1ba2","453":"03346f77","573":"196827ab","861":"a5ca547f"}[chunkId] + ".chunk.js";
};